import { GetVisitByIdVisitTypeEnum } from 'woofwoof-api';
import { translateKey } from 'src/locales/translate';


export const mapVisitTypeToLabel = (
  visitType?: GetVisitByIdVisitTypeEnum,
): string => {
  if (!visitType) {
    return '';
  }
  const visitTypeToLabel: Record<GetVisitByIdVisitTypeEnum, string> = {
    [GetVisitByIdVisitTypeEnum.Video]: 'Online',
    [GetVisitByIdVisitTypeEnum.Chat]: translateKey("visit.bookingVisitFormatChat"),
    [GetVisitByIdVisitTypeEnum.Onsite]: translateKey("hardcoded.placowka"),
    [GetVisitByIdVisitTypeEnum.Mobile]: translateKey("search.ui.tabMobile"),
  };

  return visitTypeToLabel[visitType] || visitType;
};
